import { useState, useEffect } from "react";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import QuestsListElement from "../../assets/components/questListElement";
import { useNavigate } from "react-router";
import appApi from "../../assets/utils/AppApi";
import errorHandler from "../../assets/utils/ErrorHandler";
import NoResultAlter from "../../assets/components/UI/NoResultAlter";
import Loading from "../../assets/containers/loadingDialog";
import WordGamesFilter from "./WordGamesFilter";

const WordGamesList = () => {
  const [filter, setFilter] = useState("Active");
  const [loading, setLoading] = useState(false);
  const [forms, setForms] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getAllEvents(filter);
  }, [filter]);

  const getAllEvents = async (type) => {
    setLoading(true);
    try {
      await appApi
        .get(
          `/wordgame/event/getall/user?page=1&limit=50&searchString&archived=${
            type === "Archived"
          }`
        )
        .then(({ data }) => {
          setForms(data.docs);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  return (
    <>
      <AnimatedPageContainer>
        <div className="customContainer mt-4">
          <WordGamesFilter
            selected={filter}
            handleClick={(type) => setFilter(type)}
          />
          {loading ? (
            <div className="w-100 d-flex justify-content-center py-5 my-5">
              <Loading size={30} />
            </div>
          ) : forms.length !== 0 ? (
            forms.map((item, index) => {
              return (
                <QuestsListElement
                  key={index}
                  isWG={true}
                  title={item.title}
                  subTitle={item.subtitle}
                  handleClick={() => navigate(`/eventWordGame/${item._id}`)}
                />
              );
            })
          ) : (
            <NoResultAlter className={"w-100  py-5 my-5"} />
          )}
        </div>
      </AnimatedPageContainer>
    </>
  );
};

export default WordGamesList;
